module.exports = __webpack_public_path__ + "img/VRP_Logo.f292f3e9.png";